module.exports = __webpack_public_path__ + "img/clitoris_off.5b1cde3f.gif";